module.exports = __webpack_public_path__ + "static/2-3d7804e5e34cd34bc393c09fea61f320.png";